import axios from "axios";

export default async function AddPhoneNumber(headers, data) {
  try {
    const response = await axios({
      method: "post",
      url: `https://onboardstaging.backendprod.com/api/org/whatsapp/number`,
      headers: headers,
      data: data,
    });

    const res = await response.data;
    return res;
  } catch (error) {
    throw new Error(error);
  }
}
